import React from 'react';
import { SaveButton, ClearButton, GenerateMenuButton } from '../Common/ActionsButtons';

const TemplateActions = ({ onGenerate, onClear, onSave, disabledGenerateBtn, disabledSaveBtn }) => {
  return (
    <React.Fragment>
      <GenerateMenuButton onClick={onGenerate} disabled={disabledGenerateBtn}>
        Сгенерировать шаблон
      </GenerateMenuButton>
      <ClearButton onClick={onClear} disabled={disabledGenerateBtn}>
        Очистить шаблон
      </ClearButton>
      <SaveButton onClick={onSave} disabled={disabledSaveBtn}>
        Сохранить шаблон
      </SaveButton>
    </React.Fragment>
  );
};

export default TemplateActions;



// WEBPACK FOOTER //
// ./src/Components/TemplateGenerator/TemplateActions.jsx